import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageList from '../components/PageList';
import Pagination from '../components/componentParts/Pagination';
import { useLocation } from 'react-router-dom';
import { WP_SITE_URL, WP_API, POSTS_PER_PAGE } from '../constants/constants.js'

function Pages({ match }) {
	const [pages, setPages] = useState({
		currentPage: null,
		noOfPages: null,
		isLoading: true,
		data: []
	});

	//const { page } = match.params;
	const { page   } = useParams();
	const url = useLocation().pathname;

	async function fetchPages(page) {
		try {
			//const response = await fetch(WP_SITE_URL + WP_API + 'pages?per_page=' + POSTS_PER_PAGE + '&page=' + page)
			const response = await fetch(WP_SITE_URL + WP_API + 'pages?per_page=' + POSTS_PER_PAGE + '&page=' + page)
			const data = await response.json();
			console.log(data);
			setPages({
				currentPage: data.currentPage,
				noOfPages: data.noOfPages,
				isLoading: false,
				data: data.pages
			});
		} catch (error) {
			console.error(error);
			setPages(prevState => ({
				...prevState,
				isLoading: false
			}));
		}
	}

	useEffect(() => {
		fetchPages(page);
	}, [page]);

	return (
		<div>
			{pages.isLoading ? <h2>Fetching...</h2> : <PageList pages={pages.data} />}
			<Pagination currentPage={pages.currentPage} noOfPages={pages.noOfPages} url={url} />
		</div>
	);
}

export default Pages;
